import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from 'actions'
import SelectSyaryougaisunHeight from 'components/site/select_syaryougaisun_height'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectSyaryougaisunHeightStart: state.searchFormCondition.selectSyaryougaisunHeightStart,
  selectSyaryougaisunHeightFinish: state.searchFormCondition.selectSyaryougaisunHeightFinish,
})

const SyaryougaisunHeightContainer = connect(mapStateToProps, mapDispatchToProps)(SelectSyaryougaisunHeight)

export default SyaryougaisunHeightContainer
